import { useEffect, useRef, useState } from 'react';
import { Channel } from 'types';
import TopChannel from '../Text/Top/TopChannel';
import { useParams } from 'react-router-dom';
import Spinner from '@/components/Spinner';
import Icon from '@/icons';

declare global {
    interface Window {
        Twitch: any;
    }
}

export default function WatchStreamChannel({ channel, me, socket }: { channel: Channel; me: any; socket: any }) {
    const chatRef = useRef<HTMLDivElement>(null);
    const { teamId } = useParams();
    const [isFullScreen, setIsFullScreen] = useState(false);
    useEffect(() => {
        if (!chatRef.current) return;

        const script = document.createElement("script");
        script.src = "https://embed.twitch.tv/embed/v1.js";
        script.async = true;

        const handleLoad = () => {
            if (chatRef.current) chatRef.current.innerHTML = '';


            const player = new window.Twitch.Embed(chatRef.current!, {
                width: "100%",
                height: "100%",
                channel: channel.additionalData?.streamChannel,
                theme: "dark",
            });

            player.setVolume(0.5);

            player.addEventListener(window.Twitch.Embed.VIDEO_READY, () => {

                fetch(`__SITE_BASE__/api/v1/teams/${teamId}/channels/${channel.id}/state`, {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        state: "watching",
                    }),
                });
            });

            return () => {
                player.destroy();
            };
        };

        script.onload = handleLoad;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [channel.additionalData?.streamChannel]);

    return (
        <div className={`flex flex-col w-full h-full z-20 ${isFullScreen ? "fixed top-0 left-0 w-full h-full p-2" : ""}`} key={channel.id}>
            <TopChannel channel={channel} />

            <div className="flex relative flex-col overflow-hidden border-r border-l border-gray-900 h-full"
                style={{ scrollbarWidth: "none", scrollbarColor: "rgb(40, 160, 42) rgb(27 27 29)" }} >
                <div className='absolute top-0 -z-10 left-0 w-full bg-black bg-opacity-50'>

                    <Spinner />

                </div>


                <div className="flex flex-col gap-2 w-full h-full">
                    <div className="flex flex-row h-full gap-4">
                        <div className="flex flex-col w-full h-full" ref={chatRef}></div>
                    </div>
                </div>
                <div className="absolute z-50 flex gap-2 top-2 right-2 p-2 text-white font-bold">
                    <button onClick={() => setIsFullScreen(
                        !isFullScreen
                    )} className="text-white font-bold bg-black/50 p-2 rounded-full">
                        <Icon name="fullscreen" size="12" />
                    </button>
                </div>

            </div>
        </div>


    );
}
